export default "__VITE_ASSET__Bu35Dl79__"